<template>
  <div id="PageBCorp">
    <SectionHeroBCorp />
    <SectionTrust />
    <SectionClimateStandards />
    <SectionCompleteSolution />
    <SectionWorkWithUs />
    <SectionSustainalyseDifference />
    <SectionBCorpStrategyCall />
    <SectionBCorpFAQs />
  </div>
</template>

<script setup lang="ts">
import SectionTrust from '@/views/components/sections/SectionTrust.vue'
import SectionHeroBCorp from './sections/SectionHeroBCorp.vue'
import SectionClimateStandards from './sections/SectionClimateStandards.vue'
import SectionCompleteSolution from './sections/SectionCompleteSolution.vue'
import SectionWorkWithUs from './sections/SectionWorkWithUs.vue'
import SectionSustainalyseDifference from './sections/SectionSustainalyseDifference.vue'
import SectionBCorpStrategyCall from './sections/SectionBCorpStrategyCall.vue'
import SectionBCorpFAQs from './sections/SectionBCorpFAQs.vue'
import { useSeo, getBreadcrumbStructuredData, getFAQStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// FAQ Data for structured data
const faqData = [
  {
    question: "What is B Corp certification?",
    answer: "B Corp certification is a verification from B Lab that a company meets high standards of social and environmental performance, accountability, and transparency. It demonstrates your commitment to using business as a force for good."
  },
  {
    question: "How long does B Corp certification take?",
    answer: "The B Corp certification process typically takes 6-12 months, depending on company size, complexity, and current readiness. Our consulting accelerates this timeline by helping you prepare thoroughly before submission."
  },
  {
    question: "What is the B Impact Assessment?",
    answer: "The B Impact Assessment (BIA) is a comprehensive evaluation of your company's impact on workers, community, environment, customers, and governance. Companies must score 80+ out of 200 points to qualify for B Corp certification."
  },
  {
    question: "How much does B Corp certification cost?",
    answer: "B Corp certification fees are based on annual revenue, ranging from $500 to $50,000+ per year. Our consulting services help you maximize your score and ensure a smooth certification process, saving time and resources."
  },
  {
    question: "Can Sustainalyse help improve our B Impact Assessment score?",
    answer: "Yes! Our consultants provide strategic guidance to improve your BIA score across all five impact areas. We identify quick wins, help you implement meaningful changes, and prepare comprehensive documentation. Our clients achieve an average +25 point improvement."
  }
]

// SEO Configuration with FAQ schema
useSeo(
  getSeoConfig('bcorp'),
  [
    getBreadcrumbStructuredData([
      { name: 'Home', url: 'https://sustainalyse.com/' },
      { name: 'B Corp Certification', url: 'https://sustainalyse.com/bcorp' }
    ]),
    getFAQStructuredData(faqData)
  ]
)
</script>

<style lang="scss" scoped>
#PageBCorp {
  min-height: 100vh;
  background-color: $color-ui-gray-cool-50;
}
</style>
